/**
=========================================================
* Soft UI Dashboard PRO React - v4.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';

// Soft UI Dashboard PRO React components
import SoftBox from 'components/SoftBox';
import SoftTypography from 'components/SoftTypography';
import SoftButton from 'components/SoftButton';

import SoftInput from 'components/SoftInput';
import SoftDatePicker from 'components/SoftDatePicker';

// Soft UI Dashboard PRO React base styles
import borders from 'assets/theme/base/borders';
import colors from 'assets/theme/base/colors';

// Invoice page components
import BaseLayout from 'layouts/pages/components/BaseLayout';

// Images
import logo from 'assets/images/logo-cargonauts.png';

import AddIcon from '@mui/icons-material/Add';
import CustomInputText from 'components/CustomInputText';
import CustomInputDate from 'components/CustomInputDate';

function Invoice() {
    const { borderWidth } = borders;
    const { light } = colors;
    const borderBottom = `${borderWidth[1]} solid ${light.main}`;

    return (
        <BaseLayout stickyNavbar>
            <SoftBox mt={{ xs: 4, md: 10 }} mb={{ xs: 4, md: 8 }}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} sm={10} md={8}>
                        <Card>
                            {/* Invoice header */}
                            <SoftBox p={3}>
                                <Grid container justifyContent="space-between">
                                    <Grid
                                        item
                                        xs={12}
                                        md={6}
                                        textAlign="center"
                                    >
                                        <SoftBox
                                            component="img"
                                            src={logo}
                                            width="45%"
                                        />
                                        <SoftTypography
                                            variant="h6"
                                            fontWeight="medium"
                                            sx={{ fontSize: '0.875rem' }}
                                        >
                                            Air Ocean Cargo Ltda.
                                        </SoftTypography>
                                        <SoftTypography
                                            variant="body2"
                                            fontWeight="medium"
                                            sx={{ fontSize: '0.875rem' }}
                                        >
                                            CARGA AEREA, TERRESTRE Y MARITIMA
                                        </SoftTypography>
                                        <SoftBox>
                                            <SoftTypography
                                                display="block"
                                                variant="subtitle2"
                                                color="secondary"
                                                sx={{ fontSize: '0.675rem' }}
                                            >
                                                FIDEL OTEIZA #1916 - PISO 10
                                            </SoftTypography>
                                        </SoftBox>
                                        <SoftBox>
                                            <SoftTypography
                                                display="block"
                                                variant="subtitle2"
                                                color="secondary"
                                                sx={{ fontSize: '0.675rem' }}
                                            >
                                                PROVIDENCIA - SANTIAGO DE CHILE
                                            </SoftTypography>
                                        </SoftBox>
                                        <SoftBox>
                                            <SoftTypography
                                                display="block"
                                                variant="subtitle2"
                                                color="secondary"
                                                sx={{ fontSize: '0.675rem' }}
                                            >
                                                TELEFONO: +56 2 27199550
                                            </SoftTypography>
                                        </SoftBox>
                                        <SoftBox>
                                            <SoftTypography
                                                display="block"
                                                variant="subtitle2"
                                                color="secondary"
                                                sx={{ fontSize: '0.675rem' }}
                                            >
                                                E-MAIL: info@cargonauts.cl
                                            </SoftTypography>
                                        </SoftBox>
                                    </Grid>
                                    <Grid item xs={12} md={7} lg={3}>
                                        <SoftBox
                                            width="100%"
                                            textAlign={{
                                                xs: 'left',
                                                md: 'right',
                                            }}
                                            mt={6}
                                        >
                                            <SoftBox mb={1}>
                                                <SoftTypography
                                                    variant="body2"
                                                    color="secondary"
                                                >
                                                    <CustomInputText
                                                        initialValue="USD"
                                                        textAlign="right"
                                                    />
                                                    <br />
                                                    <CustomInputText
                                                        initialValue="Direccion: KM. 28 1/2 RUTA 9 NORTE ,CABO NEGRO"
                                                        textAlign="right"
                                                    />
                                                    <br />
                                                    <CustomInputText
                                                        initialValue="Comuna: Punta Arenas"
                                                        textAlign="right"
                                                    />
                                                    <br />
                                                    <CustomInputText
                                                        initialValue="Ciudad: Magallanes"
                                                        textAlign="right"
                                                    />
                                                    <br />
                                                    <CustomInputText
                                                        initialValue="Rut: 76.030472-7"
                                                        textAlign="right"
                                                    />
                                                </SoftTypography>
                                            </SoftBox>
                                        </SoftBox>
                                    </Grid>
                                </Grid>
                                <SoftBox mt={{ xs: 5, md: 10 }}>
                                    <Grid
                                        container
                                        justifyContent="space-between"
                                    >
                                        <Grid item xs={12} md={4}>
                                            <SoftTypography
                                                variant="h6"
                                                color="secondary"
                                                fontWeight="medium"
                                            >
                                                Cobranza no
                                            </SoftTypography>
                                            <SoftTypography
                                                variant="h5"
                                                fontWeight="medium"
                                            >
                                                #0453119
                                            </SoftTypography>
                                        </Grid>
                                        <Grid item xs={12} md={7} lg={5}>
                                            <SoftBox
                                                width="100%"
                                                display="flex"
                                                flexDirection={{
                                                    xs: 'column',
                                                    md: 'row',
                                                }}
                                                alignItems={{
                                                    xs: 'flex-start',
                                                    md: 'center',
                                                }}
                                                textAlign={{
                                                    xs: 'left',
                                                    md: 'right',
                                                }}
                                                mt={{ xs: 3, md: 0 }}
                                            >
                                                <SoftBox width="50%">
                                                    <SoftTypography
                                                        variant="h6"
                                                        color="secondary"
                                                        fontWeight="medium"
                                                    >
                                                        Fecha de emision:
                                                    </SoftTypography>
                                                </SoftBox>
                                                <SoftBox width="50%">
                                                    <CustomInputDate
                                                        initialValue="2024-09-02"
                                                        textAlign="right"
                                                    />
                                                </SoftBox>
                                            </SoftBox>
                                            <SoftBox
                                                width="100%"
                                                display="flex"
                                                flexDirection={{
                                                    xs: 'column',
                                                    md: 'row',
                                                }}
                                                alignItems={{
                                                    xs: 'flex-start',
                                                    md: 'center',
                                                }}
                                                textAlign={{
                                                    xs: 'left',
                                                    md: 'right',
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                </SoftBox>
                            </SoftBox>

                            <SoftBox pl={4}>
                                <Grid item xs={12} md={7} lg={5}>
                                    <SoftBox
                                        display="flex"
                                        alignItems="center"
                                        justifyContent={{
                                            xs: 'flex-start',
                                            md: 'flex-end',
                                        }}
                                        mt={2}
                                    >
                                        <SoftTypography
                                            variant="h6"
                                            color="text"
                                            fontWeight="medium"
                                            mr={2}
                                        >
                                            Referencia:
                                        </SoftTypography>
                                        <CustomInputText initialValue="Methanex" />
                                    </SoftBox>
                                    <SoftBox
                                        display="flex"
                                        alignItems="center"
                                        justifyContent={{
                                            xs: 'flex-start',
                                            md: 'flex-end',
                                        }}
                                        mt={2}
                                    >
                                        <SoftTypography
                                            variant="h6"
                                            color="text"
                                            fontWeight="medium"
                                            mr={2}
                                        >
                                            Origen/Destino:
                                        </SoftTypography>
                                        <CustomInputText initialValue="Miami/Santiago" />
                                    </SoftBox>
                                </Grid>
                            </SoftBox>

                            {/* Invoice table */}
                            <SoftBox p={3}>
                                <SoftBox width="100%" overflow="auto">
                                    <Table sx={{ minWidth: '32rem' }}>
                                        <SoftBox component="thead">
                                            <TableRow>
                                                <SoftBox
                                                    component="th"
                                                    width={{
                                                        xs: '45%',
                                                        md: '50%',
                                                    }}
                                                    py={1.5}
                                                    px={1}
                                                    textAlign="left"
                                                    borderBottom={borderBottom}
                                                >
                                                    <SoftTypography
                                                        variant="h6"
                                                        color="text"
                                                        fontWeight="medium"
                                                    >
                                                        Detalle
                                                    </SoftTypography>
                                                </SoftBox>
                                                <SoftBox
                                                    component="th"
                                                    py={1.5}
                                                    pl={3}
                                                    pr={1}
                                                    textAlign="left"
                                                    borderBottom={borderBottom}
                                                >
                                                    <SoftTypography
                                                        variant="h6"
                                                        color="text"
                                                        fontWeight="medium"
                                                    >
                                                        Cantidad
                                                    </SoftTypography>
                                                </SoftBox>
                                                <SoftBox
                                                    component="th"
                                                    py={1.5}
                                                    pl={3}
                                                    pr={1}
                                                    textAlign="left"
                                                    borderBottom={borderBottom}
                                                >
                                                    <SoftTypography
                                                        variant="h6"
                                                        color="text"
                                                        fontWeight="medium"
                                                    >
                                                        Valor
                                                    </SoftTypography>
                                                </SoftBox>
                                                <SoftBox
                                                    component="th"
                                                    py={1.5}
                                                    pl={3}
                                                    pr={1}
                                                    textAlign="left"
                                                    borderBottom={borderBottom}
                                                >
                                                    <SoftTypography
                                                        variant="h6"
                                                        color="text"
                                                        fontWeight="medium"
                                                    >
                                                        Total
                                                    </SoftTypography>
                                                </SoftBox>
                                            </TableRow>
                                        </SoftBox>
                                        <TableBody>
                                            <TableRow>
                                                <SoftBox
                                                    component="td"
                                                    textAlign="left"
                                                    p={1}
                                                    borderBottom={borderBottom}
                                                >
                                                    <CustomInputText initialValue="USD" />
                                                </SoftBox>
                                                <SoftBox
                                                    component="td"
                                                    textAlign="left"
                                                    py={1}
                                                    pr={1}
                                                    pl={3}
                                                    borderBottom={borderBottom}
                                                >
                                                    <CustomInputText initialValue="1" />
                                                </SoftBox>
                                                <SoftBox
                                                    component="td"
                                                    textAlign="left"
                                                    py={1}
                                                    pr={1}
                                                    pl={3}
                                                    borderBottom={borderBottom}
                                                >
                                                    <CustomInputText initialValue="$ 8,917.41" />
                                                </SoftBox>
                                                <SoftBox
                                                    component="td"
                                                    textAlign="left"
                                                    py={1}
                                                    pr={1}
                                                    pl={3}
                                                    borderBottom={borderBottom}
                                                >
                                                    <CustomInputText initialValue="$ 8,917.41" />
                                                </SoftBox>
                                            </TableRow>

                                            <SoftBox
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                width="100%"
                                                mt={2}
                                            >
                                                <SoftButton
                                                    variant="gradient"
                                                    color="success"
                                                    onClick={() =>
                                                        window.print(this)
                                                    }
                                                >
                                                    <AddIcon />
                                                </SoftButton>
                                            </SoftBox>
                                            <TableRow>
                                                <SoftBox
                                                    component="td"
                                                    textAlign="left"
                                                    p={1}
                                                    borderBottom={borderBottom}
                                                />
                                                <SoftBox
                                                    component="td"
                                                    textAlign="left"
                                                    py={1}
                                                    pr={1}
                                                    pl={3}
                                                    borderBottom={borderBottom}
                                                />
                                                <SoftBox
                                                    component="td"
                                                    textAlign="left"
                                                    py={1}
                                                    pr={1}
                                                    pl={3}
                                                    borderBottom={borderBottom}
                                                >
                                                    <SoftTypography variant="h5">
                                                        Total
                                                    </SoftTypography>
                                                </SoftBox>
                                                <SoftBox
                                                    component="td"
                                                    textAlign="left"
                                                    py={1}
                                                    pr={1}
                                                    pl={3}
                                                    borderBottom={borderBottom}
                                                >
                                                    <SoftTypography variant="h5">
                                                        $ 8,917.41
                                                    </SoftTypography>
                                                </SoftBox>
                                            </TableRow>
                                        </TableBody>
                                    </Table>
                                </SoftBox>
                            </SoftBox>

                            {/* Invoice footer */}
                            <SoftBox p={3} mt={7}>
                                <Grid container>
                                    <Grid item xs={12} lg={7}>
                                        <SoftBox
                                            width="100%"
                                            height={{ xs: 'auto', md: '100%' }}
                                            display="flex"
                                            justifyContent={{
                                                xs: 'flex-start',
                                                md: 'flex-end',
                                            }}
                                            alignItems="flex-end"
                                            mt={{ xs: 2, md: 0 }}
                                        >
                                            <SoftTypography variant="h6">
                                                Esta cobranza debe ser paga en
                                                USD/EUR (MONEDA ORIGINAL). El
                                                tipo de cambio es solo
                                                referencial.
                                            </SoftTypography>
                                        </SoftBox>
                                    </Grid>
                                </Grid>
                                <Grid container mt={4}>
                                    <Grid item xs={12} lg={7}>
                                        <SoftBox
                                            width="100%"
                                            height={{ xs: 'auto', md: '100%' }}
                                            display="flex"
                                            justifyContent={{
                                                xs: 'flex-start',
                                                md: 'flex-end',
                                            }}
                                            alignItems="flex-end"
                                            mt={{ xs: 2, md: 0 }}
                                        >
                                            <SoftButton
                                                variant="gradient"
                                                color="info"
                                                onClick={() =>
                                                    window.print(this)
                                                }
                                            >
                                                Guardar
                                            </SoftButton>
                                        </SoftBox>
                                    </Grid>
                                </Grid>
                            </SoftBox>
                        </Card>
                    </Grid>
                </Grid>
            </SoftBox>
        </BaseLayout>
    );
}

export default Invoice;
